export type AssignmentSource = 'override' | 'template' | 'person_default';
/** date → personId → shiftUnitId → source */
export type ProvenanceMap = Record<string, Record<string, Record<string, AssignmentSource>>>;
